const members = [
  [
    {
      name: "Med Aziz Derbali",
      position: "Chair",
      facebook: "https://www.facebook.com/aziz.derbali.1",
      image:
        "https://res.cloudinary.com/dndykifci/image/upload/v1759428991/WhatsApp_Image_2025-09-24_%C3%A0_17.04.59_9a8561f2_nkuzfa.jpg",
    },
  ],
  [
    {
      name: "Samar Moulahi",
      position: "Vice chair membership activities",
      facebook: "https://www.facebook.com/moulahi.skn",
      image:
        "https://res.cloudinary.com/dndykifci/image/upload/v1759428991/WhatsApp_Image_2025-09-24_%C3%A0_17.04.59_2a44686a_awcq2m.jpg",
    },
    {
      name: "Badie Sakka",
      position: "Vice chair technical activities",
      facebook: "https://www.facebook.com/BadieSakka",
      image:
        "https://res.cloudinary.com/dndykifci/image/upload/v1759428990/WhatsApp_Image_2025-09-24_%C3%A0_17.04.58_00272895_xf3rfe.jpg",
    },
  ],
  [
    {
      name: "Maram Ben Said",
      position: "General secretary",
      facebook: "https://www.facebook.com/maram.bensaid.5",
      image:
        "https://res.cloudinary.com/dndykifci/image/upload/v1759428991/WhatsApp_Image_2025-09-24_%C3%A0_23.04.07_4cee26ce_dyyl8e.jpg",
    },
    {
      name: "Hiba Elghali",
      position: "Treasurer",
      facebook: "https://www.facebook.com/hibaleghali23",
      image:
        "https://res.cloudinary.com/dndykifci/image/upload/v1759428861/a_qcnsx0.webp",
    },
  ],
  [
    {
      name: "Med Amine Aissaoui",
      position: "Media Manager",
      facebook: "https://www.facebook.com/search/top?q=aissaoui%20med%20amine",
      image:
        "https://res.cloudinary.com/dndykifci/image/upload/v1759428991/WhatsApp_Image_2025-09-24_%C3%A0_17.04.58_d4a48af1_aswlei.jpg",
    },
    {
      name: "Haroun Ben Romdhane",
      position: "Logistics & Industrial Visits Manager",
      facebook: "https://www.facebook.com/haroun.benromdhan.2025/",
      image:
        "https://res.cloudinary.com/dndykifci/image/upload/v1759428990/WhatsApp_Image_2025-09-24_%C3%A0_17.04.57_98e6e600_uyhz7w.jpg",
    },
  ],
];

export default members;
